import type { StationKind } from '@/content/schema';
import { build } from './build';
import { compare } from './compare';
import { drawings } from './drawings';
import { intro } from './intro';
import { projects } from './projects';
import { revit } from './revit';
import { rules } from './rules';
import type { StationImpl } from './types';
import { world } from './world';

export const STATIONS: Partial<Record<StationKind, StationImpl>> = {
  intro,
  revit,
  build,
  compare,
  drawings,
  rules,
  world,
  projects,
};

// kinds whose station has not landed yet run the intro rig
export function stationImpl(kind: StationKind): StationImpl {
  return STATIONS[kind] ?? intro;
}
